import { hasUnsavedWork, isDeferred } from '../panelCloseGuards';
import { useUiOutdated } from '@/hooks/useUiOutdated';
import type { DeferredDeparture, ShellControl, ViewState } from '@/types/panels';

type OpenPanel = ShellControl['openPanel'];

/**
 * Wraps the open of the side rail. A page that runs an outdated build loads the new one when the
 * person goes to another panel: the screen changes then anyway, and the reload lands on the panel
 * they asked for.
 */
export function useUpdateOnOpen(openPanel: OpenPanel): OpenPanel {
    const isOutdated = useUiOutdated();
    return (id, props, opts): ViewState | DeferredDeparture => {
        const openedValue = openPanel(id, props, opts);
        // An open that waits for an answer about unsaved work has not landed yet.
        if (isOutdated && !isDeferred(openedValue)) {
            // After the task: the open writes its URL in a microtask.
            setTimeout((): void => {
                if (!hasUnsavedWork()) {
                    window.location.reload();
                }
            }, 0);
        }
        return openedValue;
    };
}
